/**
 * This is a temporary component to indicate that a series has been migrated.
 * It will be removed then the slide migration project is finished.
 */

import { useIsSlideDeckMigrated } from '@mentimeter/compatibility/migration-status';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Warning } from '@mentimeter/ragnar-visuals';
import { Tooltip } from '@mentimeter/ragnar-ui/tooltip';

export function MigratedSeriesIndicator() {
  const isSlideDeckMigrated = useIsSlideDeckMigrated();

  return isSlideDeckMigrated ? (
    <Tooltip
      trigger={
        <Box
          width={24}
          height={24}
          top={4}
          left={4}
          position="absolute"
          zIndex={100}
        >
          <Warning />
        </Box>
      }
    >
      This presentation is migrated to the new domain model
    </Tooltip>
  ) : null;
}
